import PropTypes from "prop-types";
const ImageUploadPropTypes = {
  dataHook: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  imagesPool: PropTypes.array,
  small: PropTypes.bool,
  disabled: PropTypes.bool
};
export {
  ImageUploadPropTypes
};
//# sourceMappingURL=types.js.map
